<div class="modal-header modalHeaderDefault">
  <h6 class="modal-title">{{ "AppointmentListPage.confirm" | translate}}</h6>
  <span aria-label="Close" class="close" (click)="onNoClick()" [matTooltip]="'common.close' | translate">
    <mat-icon >clear</mat-icon>
  </span>
  
</div>
<div class="patient-block-body">
 
  <mat-form-field
    style="padding-top: 10px; padding-bottom: 3px"
    class="fieldBox"
    appearance="outline"
  >
    <mat-label>{{ "billing.reason" | translate }}</mat-label>
    <mat-select [required]="true" [(ngModel)]="selectedReason" name="reason">
      <mat-option>
        <ngx-mat-select-search
          [formControl]="reasonSearch"
          [placeholderLabel]="'payerInfo.reason' | translate"
        ></ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let reason of reasonSample" [(value)]="reason.code">
        {{reason.desc}}
      </mat-option>
    </mat-select>
  </mat-form-field>

    <p style="padding-bottom: 5px;">
        <mat-form-field class="fieldBox mt-15" appearance="outline">
        <mat-label>{{ "billing.remarks" | translate }}</mat-label>
        <input matInput [placeholder]="'AppointmentListPage.remarks' | translate" maxlength="250" [(ngModel)]="selectedRemarks" name = "remarks" pattern="[a-zA-Z0-9]+">
        </mat-form-field>
    </p>
    <div>
        <td style="float: right; padding-right: 5px; padding-bottom: 5px; padding-top: -10px;"> 
            <button mat-mini-fab class="btnRed" color="primary" matTooltip="{{ 'EncounterListPage.cancel' | translate }}" 
            (click)="onNoClick()">
                <mat-icon>clear</mat-icon>
            </button>
        </td>
    </div>
    <div>
        <td style="float: right; padding-right: 5px; padding-bottom: 5px; padding-top: -10px;"> 
            <button mat-mini-fab class="btnGreen" color="primary" matTooltip="{{ 'AppointmentListPage.confirm' | translate }}" 
            (click)="onConfirm(selectedRemarks, selectedReason)">
                <mat-icon>check_circle</mat-icon>
            </button>
        </td>
    </div>
  <!-- <div>
    <td
      style="
        float: right;
        padding-right: 5px;
        padding-bottom: 5px;
        padding-top: -10px;
      "
    >
      <button mat-mini-fab class="btnGreen" color="primary">
        <mat-icon
          matTooltip="{{ 'AppointmentListPage.confirm' | translate }}"
          (click)="onConfirm(selectedRemarks, selectedReason)"
          >check_circle</mat-icon
        >
      </button>
    </td>
  </div> -->
</div>
